import type { Language } from "../../contexts/LanguageContext";

export const onboardingLabels: Record<Language, {
  title: string;
  language: { label: string; pt: string; en: string; searchPlaceholder: string; emptyMessage: string };
  actions: { save: string };
}> = {
  pt: {
    title: "Configurações iniciais",
    language: {
      label: "Idioma",
      pt: "Português",
      en: "Inglês",
      searchPlaceholder: "Buscar idioma...",
      emptyMessage: "Nenhum idioma encontrado.",
    },
    actions: { save: "Salvar" },
  },
  en: {
    title: "Initial settings",
    language: {
      label: "Language",
      pt: "Portuguese",
      en: "English",
      searchPlaceholder: "Search language...",
      emptyMessage: "No languages found.",
    },
    actions: { save: "Save" },
  },
};
